import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { RecaptchaComponent } from '../../recaptcha/recaptcha.component';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    RecaptchaComponent,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm!: FormGroup;
  isSubmitting = false;
  errorMessage = '';
  successMessage = '';
  recaptchaToken = '';
  recaptchaErrorMessage = '';

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });

    setTimeout(() => {
      document.querySelector('.forgot-password-form')?.classList.add('visible');
    }, 100);
  }

  get email() {
    return this.forgotPasswordForm.get('email');
  }

  onRecaptchaChange(token: string): void {
    this.recaptchaToken = token;
    this.recaptchaErrorMessage = '';
  }

  onRecaptchaError(error: string): void {
    this.recaptchaToken = '';
    this.recaptchaErrorMessage = error;
  }

  onSubmit(): void {
    if (this.forgotPasswordForm.invalid) {
      Object.keys(this.forgotPasswordForm.controls).forEach((key) => {
        const control = this.forgotPasswordForm.get(key);
        control?.markAsTouched();
      });
      return;
    }

    if (!this.recaptchaToken) {
      this.recaptchaErrorMessage = 'Please complete the security verification';
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';
    this.successMessage = '';

    this.authService
      .forgotPassword(this.email?.value, this.recaptchaToken)
      .subscribe({
        next: (response) => {
          this.isSubmitting = false;
          this.successMessage =
            response.message ||
            'Password reset link has been sent to your email.';
          this.forgotPasswordForm.reset();
          this.recaptchaToken = '';
        },
        error: (error) => {
          this.isSubmitting = false;
          this.errorMessage =
            error.message ||
            'Failed to process password reset request. Please try again.';
          this.recaptchaToken = '';
        },
      });
  }
}
